import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { SuperAdminService } from "../../../super-admin.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { debounce } from "lodash";

@Component({
  selector: "app-users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.css"],
})
export class UsersListComponent implements OnInit, AfterViewInit {
  users: any[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumns: string[] = ["full_name", "email", "isactive", "action"];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("data") searchInput: ElementRef;

  // pagination + search
  page: number = 1;
  limit: number = 10;
  totalRecords: number = 0;
  searchTerm: string = "";
userSessionData: any;
isAdmin: boolean = false;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.userSessionData = JSON.parse(sessionStorage.getItem("userSession"));
    if (this.userSessionData?.user_role_id?.[0] === 1) {
      this.isAdmin = true;
    }
    this.dataSource = new MatTableDataSource<any>([]);
    this.getUsers();
  }

  ngAfterViewInit() {
    // debounced search
    const debouncedSearch = debounce(() => {
      this.page = 1;
      this.getUsers();
    }, 300);

    this.searchInput.nativeElement.addEventListener("input", (event: any) => {
      this.searchTerm = event.target.value.trim();
      debouncedSearch();
    });
    this.dataSource.sort = this.sort;
  }

  async getUsers() {
    this.spinner.show();

    this.superAdminService
      .getUsers(this.page, this.limit, this.searchTerm)
      .subscribe({
        next: (res: {
          status: any;
          message: any;
          data: any;
          pagination: any;
        }) => {
          this.spinner.hide();

          if (res.status === true) {
            this.users = res.data || [];
            this.dataSource.data = this.users;

            this.applyDefaultSort();

            if (res.pagination) {
              this.totalRecords = res.pagination.totalRecords;
              this.limit = res.pagination.pageSize;
              this.page = res.pagination.currentPage;

              // Sync paginator
              if (this.paginator) {
                this.paginator.pageIndex = this.page - 1;
              }
            }
          } else {
            if (res.status === 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.error(res.message);
            }
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error("Something went wrong! Please contact support.");
        },
      });
  }

  sortData(sort: Sort) {
    const data = [...this.dataSource.filteredData]; 
    if (!sort.active || sort.direction === "") {
      this.dataSource.data = this.users;
      return;
    }

    const isAsc = sort.direction === "asc";

    this.dataSource.data = data.sort((a, b) => {
      switch (sort.active) {
        case "date":
          return compare(a.date, b.date, isAsc);
        case "amount":
          return compare(+a.amount, +b.amount, isAsc);
        case "company_name":
          return compare(lower(a.company_name), lower(b.company_name), isAsc);
        case "supervisor_name":
          return compare(
            lower(a.supervisor_name),
            lower(b.supervisor_name),
            isAsc
          );
        default:
          return 0;
      }
    });

    function compare(a: string | number, b: string | number, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    function lower(value: any) {
      return value ? value.toString().toLowerCase() : "";
    }
  }

  private applyDefaultSort() {
    const defaultSort: Sort = {
      active: "full_name",
      direction: "desc",
    };
    this.sortData(defaultSort);
  }

  // handle paginator events
  onPageChange(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    this.getUsers();
  }

  emitdata(params: any) {
    sessionStorage.setItem("userdata", JSON.stringify(params));
  }

  deleteuser(email: string) {
    if (this.superAdminService.deleteDailogBox()) {
      this.superAdminService.deleteuser(email).subscribe(
        (res: { status: any; message: any; authorization: any; code: any }) => {
          if (res.status === true) {
            this.toastr.success(res.message);
            this.page = 1;
            this.getUsers();
          } else {
            if (res.status === 401) {
              this.toastr.error(res.message);
              window.sessionStorage.clear();
              this.router.navigateByUrl("superAuth/login");
            } else {
              this.toastr.error(res.message);
            }
          }
        },
        () => {
          this.toastr.error("Failed to delete user. Try again later.");
        }
      );
    }
  }
}
